module.exports = __webpack_public_path__ + "static/media/icon_editar.fe3c41f9.svg";